import React, { useRef, useMemo } from 'react';
import { StickyActions } from '@upgrade/react-components';
import useIntersectionObserver from '@upgrade/react-components/hooks/useIntersectionObserver';
import { Text } from '../TypographyPublicSite';

import { StyledButton } from './styles';

const CTAButton = ({
  ctaButtonText,
  ariaLabel,
  buttonProps,
  linkUrl,
  onClick,
  emphasis,
  destructive,
  className,
  sticky = false,
  reverseFocus = false
}) => {
  const ctaRef = useRef();
  const options = useMemo(() => {
    return {
      root: null,
      rootMargin: '-100px 0px 0px 0px',
      threshold: 0
    };
  }, []);

  const { inView } = useIntersectionObserver(ctaRef, options);
  const isStickyCta = sticky && !inView;

  const button = (
    <StyledButton
      buttonProps={{
        ...buttonProps,
        'data-cta-type': isStickyCta ? 'StickyCta' : 'RegularCta',
        'aria-label': ariaLabel
      }}
      href={linkUrl}
      {...{ onClick, className, emphasis, destructive, reverseFocus }}
    >
      <Text size="md">{ctaButtonText}</Text>
    </StyledButton>
  );

  return (
    <div ref={ctaRef}>
      {isStickyCta ? (
        <StickyActions breakpoint="md" hideChildren={false}>
          {button}
        </StickyActions>
      ) : (
        button
      )}
    </div>
  );
};

export default CTAButton;
